import { ContactsApiProvider } from './contactsapi.services';

export const fetchAgentTasks = (perId) => {
  return ContactsApiProvider.get(`/calendareventtasks/members/${perId}`);
};

export const fetchSingleTaskById = (taskId) => {
  return ContactsApiProvider.get(`/calendareventtasks/${taskId}`);
};

export const fetchTasksForContact = (contactId) => {
  return ContactsApiProvider.get(`/calendareventtasks/contacts/${contactId}`);
};

export const updateTask = (taskId, calendarEventTask) => {
  return ContactsApiProvider.put(`/calendareventtasks/${taskId}`, calendarEventTask);
};

export const updateTaskUsingPatch = (taskId, calendarEventTask) => {
  return ContactsApiProvider.patch(`/calendareventtasks/${taskId}`, calendarEventTask);
};
